module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-wetsuit--spring-4ba5776dd096d9508daab66163cc8e78.svg";